import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {

  @Input() config: any;
  @Output() pageChange: EventEmitter<any> = new EventEmitter();

  onPageChange(event: any) {
    this.config.currentPage = event;
    this.pageChange.emit(this.config.currentPage);
  }
}
